import { Injectable } from '@angular/core';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { GoogleMapType } from '../../enums/google-map-enum';
import { GoogleMapStoreModel } from '../../models/google-map-model';
import { HybridGoogleMap } from '../../models/hybrid-google-map';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapStoreService {

  private readonly googleMapList: Array<GoogleMapStoreModel> = [];

  constructor() { }

  public setGoogleMap(mapType: GoogleMapType, googleMap: IGoogleMap, instance: HybridGoogleMap): IGoogleMap {
    const existingGoogleMapModel: GoogleMapStoreModel = this.googleMapList.filter( mapItem => {
      return mapItem.mapType === mapType;
    })[0];

    // update
    if (existingGoogleMapModel) {
      existingGoogleMapModel.googleMap = googleMap;
      existingGoogleMapModel.mapInstance = instance;
    } else { // amend
      const mapStoreModel: GoogleMapStoreModel = new GoogleMapStoreModel(mapType, googleMap, instance);
      this.googleMapList.push(mapStoreModel);
    }

    return googleMap;
  }

  public destroy(mapType: GoogleMapType): void {
    const existingGoogleMap: GoogleMapStoreModel = this.getGoogleMapModel(mapType);
    existingGoogleMap.googleMap = null;
    delete existingGoogleMap.mapInstance;

    const index = this.googleMapList.findIndex(item => item.mapType === mapType);
    if (index !== -1) {
      this.googleMapList.splice(index, 1);
    }
  }

  // return by default routeplaner google map instanse
  public getGoogleMap(mapType: GoogleMapType = GoogleMapType.ROUTE_PLANNER): IGoogleMap {
    const existingGoogleMap: GoogleMapStoreModel = this.getGoogleMapModel(mapType);

    return (existingGoogleMap) ? existingGoogleMap.googleMap : null;
  }

  public getGoogleMapModel(mapType: GoogleMapType = GoogleMapType.ROUTE_PLANNER): GoogleMapStoreModel {
    if (!mapType) {
      mapType = GoogleMapType.ROUTE_PLANNER;
    }

    const existingGoogleMap = this.googleMapList.filter( mapItem => {
      return (mapItem.mapType === mapType);
    })[0];

    return (existingGoogleMap) ? existingGoogleMap : null;
  }

}
